import React from 'react';
import { SearchMobileType } from '../search-mobile-type/SearchMobileType';
import { SearchBarField } from './field/SearchBarField';
import styles from './search_bar.module.scss';

export function SearchBar() {
  return (
    <div className={styles.wrapper}>
      <SearchBarField />
      <SearchMobileType />
    </div>
  );
}
